import { InfoOutline } from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { useProgress } from "context/ProgressProvider";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import {
  AppFormikTextField,
  AppPrimaryButton,
  BlackTooltip,
} from "shared/components/AppComponents";
import { AccountantSchema } from "shared/helpers/Schema";
import { ProfileActions } from "state/profile/Action";
import { LoanService } from "services/LoanService";
import Utils, { DefaultPagination } from "shared/helpers/Utils";

const AccountantDetails = () => {
  const { handleCompleteAndNext, currentProfile, isBroker } = useProgress();
  const dispatch = useDispatch();

  const handleAddAccountantDetails = (value, formik) => {
    if (currentProfile.isAllowedToEdit) {
      if (!currentProfile.isAllowedToEdit?.accountantDetails) {
        handleCompleteAndNext();
        return;
      }
    }

    LoanService.addSolicitorDetails(
      {
        firstName: value.accountantFirstName,
        lastName: value.accountantLastName,
        email: value.accountantWorkEmailAddress,
        businessName: value.accountantBusinessName,
      },
      currentProfile.loadId,
    )
      .then((response: any) => {
        handleCompleteAndNext();
      })
      .catch((error: any) => {
        Utils.handleErrorResponse(error);
      })
      .finally(() => {
        formik?.setSubmitting(false);
      });
  };

  const handleSubmitForm = (value, formik) => {
    formik?.setSubmitting(true);
    console.log(value);
    dispatch(ProfileActions.setRndProfile(value));
    handleAddAccountantDetails(value, formik);
  };

  return (
    <>
      <Box>
        <Typography variant="h2">
          Accountant details{" "}
          <BlackTooltip title="A accountant can witness and execute documents to speed up settlement.">
            <InfoOutline fontSize={"small"} sx={{ marginLeft: "10px" }} />
          </BlackTooltip>
        </Typography>
        <Typography variant="h3" fontWeight={400}>
          {isBroker ? (
            <>
              As the documents will require a witness and often legal execution,
              we have decided to simplify this process to allow your customer
              Accountant to act in both circumstances in order to reduce time to
              settlement.
            </>
          ) : (
            <>
              As the documents will require a witness and often legal execution,
              we have decided to simplify this process to allow your Accountant
              to act in both circumstances in order to reduce time to
              settlement.
            </>
          )}
        </Typography>

        <Box sx={{ marginTop: "2rem" }}></Box>
        <Formik
          enableReinitialize
          validationSchema={AccountantSchema}
          validateOnMount
          onSubmit={(formValues, formik) => {
            handleSubmitForm(formValues, formik);
          }}
          initialValues={{
            accountantFirstName: currentProfile.accountantFirstName,
            accountantLastName: currentProfile.accountantLastName,
            accountantBusinessName: currentProfile.accountantBusinessName,
            accountantWorkEmailAddress:
              currentProfile.accountantWorkEmailAddress,
          }}
        >
          {({ handleSubmit, errors, isSubmitting }) => {
            console.log(errors);
            return (
              <form autoComplete="off">
                <Box>
                  <Grid container spacing={4}>
                    <Grid size={{ xs: 12, md: 6 }} component="div">
                      <AppFormikTextField
                        placeholder="First name"
                        label="First name"
                        name="accountantFirstName"
                        outerLabel
                        className="ezifin-default-field"
                      />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }} component="div">
                      <AppFormikTextField
                        placeholder="Last name"
                        label="Last name"
                        name="accountantLastName"
                        outerLabel
                        className="ezifin-default-field"
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box mt={3}>
                  <AppFormikTextField
                    placeholder="Business name"
                    label="Business name"
                    name="accountantBusinessName"
                    outerLabel
                    className="ezifin-default-field"
                  />
                </Box>

                <Box mt={3}>
                  <AppFormikTextField
                    placeholder="Work email address"
                    label="Work email address"
                    name="accountantWorkEmailAddress"
                    outerLabel
                    className="ezifin-default-field"
                  />
                </Box>

                <Box mt={3}>
                  <AppPrimaryButton
                    title="Continue"
                    isLoading={isSubmitting}
                    loadingText="Please wait.."
                    onClick={handleSubmit}
                    disabled={Object.keys(errors).length > 0 || isSubmitting}
                  />
                </Box>
              </form>
            );
          }}
        </Formik>
      </Box>
    </>
  );
};

export default AccountantDetails;
